import Main from './Main'
import New from './New'
import Edit from './Edit'
import Show from './Show'

export default [
  { path: '/taxes', name: 'taxes', component: Main },
  { path: '/taxes/new', name: 'new_tax', component: New },
  { path: '/taxes/edit/:id', name: 'edit_tax', component: Edit },
  { path: '/taxes/:id', name: 'tax_details', component: Show }
]



// WEBPACK FOOTER //
// ./src/app/pages/taxes/routes.js